// src/hooks/useAssignmentRules.js
import { useState, useEffect, useCallback } from "react";
import { doc, onSnapshot, setDoc } from "firebase/firestore";
import { db } from "../firebase";

function rulesDoc(orgId) {
  return doc(db, "organizations", orgId, "settings", "assignmentRules");
}

export function useAssignmentRules(orgId) {
  const [rules, setRules] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!orgId) return;
    setLoading(true);
    return onSnapshot(
      rulesDoc(orgId),
      (snap) => {
        setRules(snap.exists() ? (snap.data().rules || []) : []);
        setLoading(false);
      },
      () => setLoading(false)
    );
  }, [orgId]);

  const saveRules = useCallback(async (newRules) => {
    await setDoc(rulesDoc(orgId), { rules: newRules }, { merge: false });
  }, [orgId]);

  const addRule = useCallback(async (rule) => {
    const id = `${Date.now().toString(36)}_${Math.random().toString(36).slice(2, 6)}`;
    await saveRules([...rules, { ...rule, id }]);
  }, [rules, saveRules]);

  const removeRule = useCallback(async (ruleId) => {
    await saveRules(rules.filter((r) => r.id !== ruleId));
  }, [rules, saveRules]);

  return { rules, loading, addRule, removeRule };
}
